import { UserEvent } from "../../types";

export interface UserEventsProps {
  events: UserEvent[];
  isLoading: boolean;
}

export const statisticsUserEventsDefault: UserEventsProps = {
  events: [],
  isLoading: true
};
